import { useDispatch } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { Action } from 'redux'

export const useAppDispatch = <T extends ThunkDispatch<any, any, Action>>(): T => useDispatch<T>()
